import { render } from "./TheDataPrivacy.vue?vue&type=template&id=5429abaa&scoped=true"
const script = {}

import "./TheDataPrivacy.vue?vue&type=style&index=0&id=5429abaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5429abaa"]])

export default __exports__